/* eslint-disable @next/next/no-img-element, react/forbid-component-props */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import { WOWCHER_VIP_CUE } from '../../brands/default/content/components/checkout';
import { VIP_IMG } from '../../config/constants/images';

const WowcherVipCue = ({ showText = true, userprofile }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const target = useRef(null);
  const isTouch = 'ontouchstart' in window;
  const buttonClass = classNames('wowcher-vip-button', {
    'wowcher-vip-button__active': userprofile?.vipNumber,
    'wowcher-vip-button__inactive': !userprofile?.vipNumber,
  });

  const handleBlur = () => {
    setShowTooltip(false);
  };

  const handleMouseEnter = () => {
    if (isTouch) return;
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    if (isTouch) return;
    setShowTooltip(false);
  };

  const handleClick = () => {
    setShowTooltip(!showTooltip);
  };

  return (
    <>
      <div className="wowcher-vip">
        {showText && WOWCHER_VIP_CUE.socialCue}
        <span>
          <button
            className={buttonClass}
            onBlur={handleBlur}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            ref={target}
            type="button"
          >
            <img
              alt={WOWCHER_VIP_CUE.socialCueAlt}
              className="wowcher-vip-img"
              src={VIP_IMG}
            />
          </button>
        </span>
        <Overlay
          placement="left"
          show={userprofile?.vipNumber && showTooltip}
          target={target.current}
        >
          {(props) => (
            <Popover id="popover-basic" {...props}>
              <Popover.Content className="popover-content">
                {userprofile?.vipNumber && (
                  <div className="popover-content">
                    VIP number: <b>{userprofile?.vipNumber}</b>
                    <br />
                    Membership Expiry : <b>{userprofile?.vipValidity}</b>
                  </div>
                )}
              </Popover.Content>
            </Popover>
          )}
        </Overlay>
      </div>
      <style jsx>{`
        .wowcher-vip {
          display: inline;
          font-weight: bold;
          font-size: 14px;
          color: #9a9999;
        }
        .wowcher-vip-button {
          background-color: transparent;
          border: 0;
        }
        .wowcher-vip-button__active {
          cursor: pointer;
        }
        .wowcher-vip-button__inactive {
          cursor: default;
        }
        .wowcher-vip-img {
          width: 64px;
          height: 41px;
        }
        .popover-content {
          font-size: 13px;
        }
      `}</style>
    </>
  );
};

WowcherVipCue.propTypes = {
  showText: PropTypes.bool,
  userprofile: PropTypes.object,
};

export default WowcherVipCue;
